import type { ReactNode } from 'react';

import { Box } from '#/components/Box/Box';
import { gutterWidth } from '#/theme/theme';

import { SearchBodyHolder } from './SearchBody.styled';

type Props = {
  children: ReactNode;
};

export function SearchBody({ children }: Props) {
  return (
    <SearchBodyHolder data-qa-id="search-results-body">
      <Box
        m="0 auto"
        width={[1, 1, 1, 2 / 3]}
        px={[gutterWidth / 2, gutterWidth / 2, gutterWidth / 2, gutterWidth]}
        py={[gutterWidth / 2, gutterWidth / 2, gutterWidth / 2, 0]}
        qaId="search-results"
      >
        {children}
      </Box>
    </SearchBodyHolder>
  );
}
